import React, { PropsWithChildren } from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import Text from 'core/elements/Text'

interface AlertProps {
  variant?: 'primary' | 'success' | 'warning' | 'error'
  title?: string | React.ReactNode
  message?: string | React.ReactNode
  id?: string
  className?: string
  maxWidth?: string
}

export default function Alert({
  variant = 'primary',
  title,
  message,
  id = undefined,
  className = undefined,
  children,
  maxWidth,
}: PropsWithChildren<AlertProps>) {
  const classes = useStyles()
  const titleComponent = title ? (
    typeof title === 'string' ? (
      <Text className={classes.alertTitle} variant="caption1" component="h5">
        {title}
      </Text>
    ) : (
      title
    )
  ) : null
  const msgComponent =
    typeof message === 'string' ? <Text variant="body2">{message}</Text> : message
  return (
    <article
      id={id}
      className={clsx(
        classes.alert,
        classes[`alert${variant.charAt(0).toUpperCase() + variant.slice(1)}`],
        className,
      )}
      style={{ maxWidth: maxWidth || 'unset' }}
    >
      {titleComponent}
      {msgComponent}
      {children}
    </article>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  alert: {
    width: '100%',
    boxSizing: 'border-box',
    padding: 8,
    wordBreak: 'break-word',
  },
  alertPrimary: {
    backgroundColor: theme.components.alert.primary.background,
    borderTop: `1px solid ${theme.components.alert.primary.border}`,
  },
  alertSuccess: {
    backgroundColor: theme.components.alert.success.background,
    borderTop: `1px solid ${theme.components.alert.success.border}`,
  },
  alertWarning: {
    backgroundColor: theme.components.alert.warning.background,
    borderTop: `1px solid ${theme.components.alert.warning.border}`,
  },
  alertError: {
    backgroundColor: theme.components.alert.error.background,
    borderTop: `1px solid ${theme.components.alert.error.border}`,
  },
  alertTitle: {
    marginBottom: 10,
  },
}))

/*
@todo check with design if we want to use icons in the alert

export const variantIcon = {
  success: 'check-circle',
  warning: 'exclamation-circle',
  error: 'exclamation-circle',
  info: 'info-circle',
}
<FontAwesomeIcon className={classes.icon}>
  {variantIcon[variant]}
</FontAwesomeIcon>
*/
